import { render, staticRenderFns } from "./RecommendedFile.vue?vue&type=template&id=3d08d8f7&scoped=true&"
import script from "./RecommendedFile.vue?vue&type=script&lang=js&"
export * from "./RecommendedFile.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedFile.vue?vue&type=style&index=0&id=3d08d8f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08d8f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/recommendations/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d08d8f7')) {
      api.createRecord('3d08d8f7', component.options)
    } else {
      api.reload('3d08d8f7', component.options)
    }
    module.hot.accept("./RecommendedFile.vue?vue&type=template&id=3d08d8f7&scoped=true&", function () {
      api.rerender('3d08d8f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecommendedFile.vue"
export default component.exports